import { atom } from "jotai";

import {
  DiningBookingKnownPeopleAtom,
  DiningBookingWizardDataAtom,
} from "../../stores";

export const isGroupFullOfKnownPeopleAtom = atom((get) => {
  const wizardData = get(DiningBookingWizardDataAtom);
  const knownPeople = get(DiningBookingKnownPeopleAtom);

  if (!wizardData) {
    return false;
  }

  return knownPeople.length >= wizardData.partySize;
});
